// extracted by mini-css-extract-plugin
export var stepCard = "stepCard-module--stepCard--2jhqI";
export var cardNumber = "stepCard-module--cardNumber--1dhTE";